export default __webpack_public_path__ + "a0e8fd67d6735acaa5f5e15e8b3f033b.png";